// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import BarChartSvg from '@rsuite/icon-font/lib/charts/BarChart';
var BarChart = createSvgIcon({
  as: BarChartSvg,
  ariaLabel: 'bar chart',
  category: 'charts',
  displayName: 'BarChart'
});
export default BarChart;